import { render, staticRenderFns } from "./TechChild.vue?vue&type=template&id=2aadb4b4&"
import script from "./TechChild.vue?vue&type=script&lang=js&"
export * from "./TechChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports